import { Component } from '@angular/core';

@Component({
  selector: 'app-politica-datos',
  templateUrl: './politica-datos.component.html',
  styleUrls: ['./politica-datos.component.css']
})
export class PoliticaDatosComponent {

}
